module.exports = __webpack_public_path__ + "img/3CX_basic.2c314b67.png";